import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Comparison } from './components/Comparison';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
import { TESTIMONIOS_BOTTOM, TESTIMONIOS_TOP } from './data/content';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink font-sans text-violeta-50" data-id="element-0" data-mp="28u5ysp4wd9dw">
      <Hero data-id="element-1" data-mp="28sbbj465l56n" />
      <main data-id="element-2" data-mp="28s2ztflro5x1">
        <Testimonials label="Mujeres que ya lo tienen" title="Reales. Argentina." testimonios={TESTIMONIOS_TOP} data-id="element-3" data-mp="23vkwmk634fmt" />
        <Problem data-id="element-4" data-mp="3ijfw82xf22g7" />
        <Tomos data-id="element-5" data-mp="3ihv2ugmu8pjx" />
        <Bonos data-id="element-6" data-mp="3mlj9mx3nbh44" />
        <Countdown data-id="element-7" data-mp="3mlatmwc87vop" />
        <Pricing data-id="element-8" data-mp="3mkhlbqxmcy4g" />
        <Comparison data-id="element-9" data-mp="3mjzsl4a6121a" />
        <Testimonials label="❤️ Más testimonios" title="Historias reales — Argentina" testimonios={TESTIMONIOS_BOTTOM} data-id="element-10" data-mp="3mjg8bgx1m1k3" />
        <Faq data-id="element-11" data-mp="4wxfu7a14id" />
        <FinalCta data-id="element-12" data-mp="5gez9t0lqvv" />
      </main>
      <Footer data-id="element-13" data-mp="7svdij4jt6t" />
      <StickyBar data-id="element-14" data-mp="2zld1d7i6tbah" />
    </div>;
}